// className 합치기
export const classNameBind = (arr: string[]) =>
  arr.filter(el => el !== '').join(' ');

export const isEmpty = (val: any) =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  val == null || !(Object.keys(val) || val).length;

export const isString = <T = unknown>(str: string | T): str is string =>
  typeof str === 'string';

// string 문자열 찾기
export const setSearchStr = function (str: string, val: string) {
  return str.includes(val);
};
